import { Component, type ErrorInfo, type ReactNode } from 'react'

type Props = { children: ReactNode }
type State = { hasError: boolean }

export default class JobcostErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[jobcost] Hub embed failed', error, info)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '18px 0', fontSize: 13, color: 'var(--ink3)' }}>
          Job Cost unavailable
        </div>
      )
    }
    return this.props.children
  }
}
